import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { Icon, ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import * as Yup from "yup";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function QuotesModal(props) {
  const { modal, setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);
  const [loading, setLoading] = useState(false);

  const api_error = false;

  const validationSchema = Yup.object().shape({
    status: Yup.string().required("This field is required!"),
  });

  return (
    <Fragment>
      {modal.name === "quotes_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Edit Quote Status</div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  status: modal.data ? modal.data.status : "",
                }}
                onSubmit={async (values) => {
                  setLoading(true);

                  await axios
                    .patch(`/api/quote/${modal.data.id}`, {
                      status: values.status,
                    })
                    .then((res) => {
                      setLoading(false);
                      setModal({});

                      context.notification.show(
                        "Quote status updated successfully!",
                        "success",
                        true,
                        "toast",
                        "check-circle"
                      );

                      modal.action();
                    })
                    .catch((err) => {
                      setLoading(false);
                      setModal({});

                      context.notification.show(
                        err.response.data.message,
                        "error",
                        true,
                        "toast",
                        "x-circle"
                      );
                    });
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="status"
                          type="select"
                          label="Status"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          showErrors
                          errors={errors.status}
                          touched={touched.status}
                          options={[
                            {
                              value: "created",
                              label: "Created",
                            },
                            {
                              value: "submitted",
                              label: "Submitted",
                            },
                            {
                              value: "rejected",
                              label: "Rejected",
                            },
                            {
                              value: "need_mvr",
                              label: "Need MVR",
                            },
                            {
                              value: "need_loss_runs",
                              label: "Need Loss Runs",
                            },
                            {
                              value: "need_business_history",
                              label: "Need Business History",
                            },

                            {
                              value: "confirm_cargo",
                              label: "Confirm Cargo",
                            },
                          ]}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={
                        api_error
                          ? { justifyContent: "space-between" }
                          : { justifyContent: "flex-end" }
                      }
                    >
                      {api_error && (
                        <div className={styles.errorMessage}>
                          <div className={styles.icon}>
                            <Icon image="alert-circle" />
                          </div>
                          <span>Something went wrong, check the fields.</span>
                        </div>
                      )}
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button className={styles.save} onClick={submitForm}>
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
